"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VulnerableCustomerPaymentHolidayMonthSelectionPage = exports.VulnerableCustomerPaymentHolidayMonthSelectionPagePlain = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var VulnerableCustomerAction_1 = require("../../model/VulnerableCustomerAction");
var components_1 = require("@athena-portal/components");
var react_router_dom_1 = require("react-router-dom");
var SupportPortalTemplates_1 = require("../../SupportPortalTemplates");
var VulnerableCustomerPaymentHolidayMonthSelectionPagePlain = /** @class */ (function (_super) {
    __extends(VulnerableCustomerPaymentHolidayMonthSelectionPagePlain, _super);
    function VulnerableCustomerPaymentHolidayMonthSelectionPagePlain(props) {
        var _this = _super.call(this, props) || this;
        _this.supportPortalTemplates = new SupportPortalTemplates_1.SupportPortalTemplates();
        _this.handleMonthChange = function (event) {
            _this.setState({
                actionToConfirmMonths: parseInt(event.target.value, 10)
            });
        };
        _this.state = {
            actionToConfirmMonths: 0
        };
        return _this;
    }
    VulnerableCustomerPaymentHolidayMonthSelectionPagePlain.prototype.render = function () {
        var actionToConfirmMaxMonths = 3;
        return ((0, jsx_runtime_1.jsxs)("div", { className: "panel-border", children: [(0, jsx_runtime_1.jsxs)("div", { className: "col-12 col-md-8 my-3", children: [(0, jsx_runtime_1.jsxs)("p", { children: ["Select for how many months will the ", VulnerableCustomerAction_1.VulnerableCustomerActionEnum.PAYMENT_HOLIDAY, " action be active:"] }), (0, jsx_runtime_1.jsxs)("select", { id: "vulnerable-customer-action-months", className: "form-control", name: "months", value: this.state.actionToConfirmMonths, onChange: this.handleMonthChange, children: __spreadArray([(0, jsx_runtime_1.jsx)("option", { value: 0, children: "Please select..." })], Array(actionToConfirmMaxMonths).fill(null).map(function (v, i) { return ((0, jsx_runtime_1.jsx)("option", { value: i + 1, children: i + 1 }, i + 1)); }), true) })] }), (0, jsx_runtime_1.jsxs)("div", { className: "d-flex pl-3", children: [(0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: "/customers/".concat(this.props.params.id), className: "buttonLink mr-3 btn btn-default btn-white-dashboard margin-y40", children: "Cancel" }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: "/customers/".concat(this.props.params.id, "/vulnerableCustomer/paymentHolidays/").concat(this.props.params.policyNumber, "/confirm"), state: { actionToConfirmMonths: this.state.actionToConfirmMonths }, className: "btn btn-default btn-primary", children: "Continue" })] }), this.supportPortalTemplates.renderFooter()] }));
    };
    VulnerableCustomerPaymentHolidayMonthSelectionPagePlain = __decorate([
        components_1.authorize,
        __metadata("design:paramtypes", [Object])
    ], VulnerableCustomerPaymentHolidayMonthSelectionPagePlain);
    return VulnerableCustomerPaymentHolidayMonthSelectionPagePlain;
}(React.Component));
exports.VulnerableCustomerPaymentHolidayMonthSelectionPagePlain = VulnerableCustomerPaymentHolidayMonthSelectionPagePlain;
exports.VulnerableCustomerPaymentHolidayMonthSelectionPage = (0, components_1.withRouter)(VulnerableCustomerPaymentHolidayMonthSelectionPagePlain);
//# sourceMappingURL=VulnerableCustomerPaymentHolidayMonthSelectionPage.js.map